module.exports = __webpack_public_path__ + "static/media/Voyage-Bold.043cecc1.otf";